import { render, staticRenderFns } from "./ColorLegend.vue?vue&type=template&id=5aea794e"
import script from "./ColorLegend.vue?vue&type=script&lang=js"
export * from "./ColorLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports